module.exports = __webpack_public_path__ + "img/1_1.cfe8b4c2.png";